<div class="modal-header">
  <h4 class="modal-title"><span translate>Goals for</span> {{ title | translate }}</h4>
  <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">

    <div class="text-center" [hidden]="domain == 'functioning'">
      <div class="btn-group btn-group-toggle mb-4" data-toggle="buttons" ngbRadioGroup
           name="radio1" [(ngModel)]="goalTab">
        <label *ngIf="selected == 0; else notSelected0" ngbButtonLabel class="btn btn-dark py-2 px-3" (click)="setSelectedItem(0)">
          <span translate>Challenge</span> {{1}}
        </label>
        <ng-template #notSelected0>
          <label ngbButtonLabel class="btn btn-light py-2 px-3" (click)="setSelectedItem(0)">
            <span translate>Challenge</span> {{1}}
          </label>
        </ng-template>
        <label *ngIf="selected == 1; else notSelected1" ngbButtonLabel class="btn btn-dark py-2 px-3" (click)="setSelectedItem(1)">
          <span translate>Challenge</span> {{2}}
        </label>
        <ng-template #notSelected1>
          <label ngbButtonLabel class="btn btn-light py-2 px-3" (click)="setSelectedItem(1)">
            <span translate>Challenge</span> {{2}}
          </label>
        </ng-template>
        <label *ngIf="selected == 2; else notSelected2" ngbButtonLabel class="btn btn-dark py-2 px-3" (click)="setSelectedItem(2)">
          <span translate>Challenge</span> {{3}}
        </label>
        <ng-template #notSelected2>
          <label ngbButtonLabel class="btn btn-light py-2 px-3" (click)="setSelectedItem(2)">
            <span translate>Challenge</span> {{3}}
          </label>
        </ng-template>
        <label *ngIf="selected == 3; else notSelected3" ngbButtonLabel class="btn btn-dark py-2 px-3" (click)="setSelectedItem(3)">
          <span translate>Challenge</span> {{4}}
        </label>
        <ng-template #notSelected3>
          <label ngbButtonLabel class="btn btn-light py-2 px-3" (click)="setSelectedItem(3)">
            <span translate>Challenge</span> {{4}}
          </label>
        </ng-template>
      </div>
    </div>

    <form (ngSubmit)="onSubmit()" [formGroup]="form" id="goals-form" style="padding: 0 20px;">
      <ng-container [formArrayName]="'params'">
        <div *ngFor="let dummy of params.controls; let rank = index" [hidden]="rank != selected" [formGroupName]="rank">

          <ng-container formArrayName="goals">

            <ng-container *ngFor="let goal of goalParams(rank).controls; let order = index" [formGroupName]="order">
              <div class="row align-items-center mb-4 px-3">
                <!-- <h5 class=" mb-0 blue flex-grow-1">{{'Challenge ' + (goalTab+1)}}</h5> -->
                <small class="mb-0" translate>For the next </small>&nbsp;
                <div class="mx-1 w-25"><input type="text" class="form-control grayinput text-right" placeholder="{{'Insert number' | translate}}" formControlName="target" required></div>&nbsp;
                <small class=" mb-0 text-right" translate>km</small>
              </div>
              <div >
                <div class="row align-items-center mb-2 justify-content-end">
                  <small class="mb-0 col-3 text-right" translate> I obtain a score of</small>
                  <div class="col-3 text-center" *ngIf="mode == 'start'">{{ form.value.params[rank]['goals'][order]['subparam_value']  || '??' | translate}}</div>

                  <div class="col-3" *ngIf="mode == 'edit'">
                    <input
                      type="text"
                      class="form-control grayinput text-center"
                      placeholder="{{'Insert score*' | translate}}"
                      [ngClass]="{'is-invalid': subparamValue(rank, order).invalid && subparamValue(rank, order).touched}"
                      formControlName="subparam_value" required>
                  </div>
                  <small class="mb-0 col-2"><span translate>for</span> {{ title | translate }}</small>
                  <small class="mb-0 col-2 rank-label">{{('Goal' | translate) + '' + (rank+1) + '.'+ (order+1) +'.'}}</small>

                  <div class="col-2" *ngIf="mode=='edit' && !started">
                    <button *ngIf="mayRemove(rank)" type="button" class="btn btn-primary-outline mr-2" (click)="removeGoal(rank, order)">
                        <i class="fa fa-minus-circle btn-remove"></i>
                    </button>
                    <button type="button" class="btn btn-primary-outline text-white" (click)="addGoal(rank)">
                        <i class="fa fa-plus-circle btn-add"></i>
                    </button>
                  </div>
                  <small *ngIf="subparamValue(rank, order).invalid && subparamValue(rank, order).touched" class="col-12 text-form red text-center" translate>
                    *Enter scores values >= 0 and <= 100 per goal.
                </small>
                </div>
<!--                <label class="mb-2" [hidden]="!form.value.params[rank]['goals'][0].target || !form.value.params[rank]['goals'][order]['subparam_value']">-->
<!--                  Voor de eerstvolgende {{ form.value.params[rank]['goals'][0].target || '??' }} km behaal ik minstens een-->
<!--                  score van {{ form.value.params[rank]['goals'][order]['subparam_value']  || '??'}} voor {{ title }}.-->
<!--                </label>-->
                <!--<hr *ngIf="order != 3">-->
              </div>
            </ng-container>
          </ng-container>

        </div>
      </ng-container>
    </form>
    <div class="text-left my-4" style="padding: 0 20px;">
        <small translate>
        *Enter scores values >= 0 and <= 100 per goal.
        </small>
    </div>
    <div class="text-center my-4">
      <button class="btn btn-warning text-white" form="goals-form" [hidden]="mode == 'start'" [disabled]="mode == 'start' || !form.valid || started">
        <span *ngIf="!saving || saving.closed" translate>SAVE</span>
        <span *ngIf="saving && !saving.closed" class="blink" translate>SAVING</span>
      </button>
    </div>

</div>
